export const sources = [
  "facebook",
  "influencer",
  "instagram",
  "tiktok",
  "linkedin",
  "website",
  "news",
  "News",
  "Meta",
  "meta",
  // "website+polo",
];

export function clearAllCookies() {
  const cookies = document.cookie.split(";");

  for (let cookie of cookies) {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();

    // Clear the cookie with path and domain as needed
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  }
}
